import SideText from './sideLayout';
import { matchPath, Outlet } from 'react-router';
import { useState } from 'react';
import { useEffect } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { ModeToggle } from '@/components/theme/mode-toggle';
import { useLocation } from 'react-router';
import { useTheme } from '@/components/theme/theme-provider';
import { getLogoUrl } from '@/lib/utils';

function AuthPages() {
  const location = useLocation();
  const { theme } = useTheme();
  const isCandidate =
    matchPath('/userLink/:id', location.pathname) ||
    matchPath('/userLink/:caseId/check/:checkId', location.pathname) ||
    matchPath('/public-api', location.pathname) ||
    matchPath('/public/files/:keyId', location.pathname) ||
    matchPath('/id-verification/:id', location.pathname);
  const [logoUrl, setLogoUrl] = useState('');

  useEffect(() => {
    const logoData = JSON.parse(localStorage.getItem('logo'));
    if (logoData) {
      setLogoUrl(getLogoUrl(theme));
    }
  }, [theme]);

  return (
    <>
      {isCandidate ? (
        <div>
          <Outlet />
        </div>
      ) : (
        <div className="grid grid-cols-2 max-sm:grid-cols-1 min-h-screen bg-background">
          <SideText />
          <div className="flex justify-center w-full max-md:px-8">
            <div className="absolute top-5 right-5">
              <ModeToggle />
            </div>
            <div className="flex w-full max-w-sm  max-md:justify-center flex-col justify-center">
              {!logoUrl && <Skeleton className="h-40 w-40 rounded-xl" />}
              {logoUrl && (
                <img src={logoUrl} alt="logo" className="max-h-40 max-w-40" />
              )}
              <Outlet />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AuthPages;
